import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as filesAPI from '@debbie/cortex/dist/api/files.js';
import React, { useRef } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { APIBASE } from '../config.js';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import X from './Icons/X.js';
import { Button } from './index.js';
const ImageInput = (props) => {
    const dropzoneRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const upload = useMutation(async (uploadFile) => {
        const content = await promiseFileReader(uploadFile);
        const { file } = await filesAPI.save({
            content: content.split('base64,')[1],
            name: uploadFile.name,
            contentType: uploadFile.type,
        });
        if (props.onChange) {
            props.onChange(file);
        }
    }, {
        onError: (err) => errorNotification(lang, err, 'create', lang.errorEntities.file),
    });
    return (React.createElement(Styled, null, React.createElement(Dropzone, { multiple: false, ref: dropzoneRef, acceptStyle: {
            background: 'lightgreen',
        }, rejectStyle: {
            background: 'red',
        }, disableClick: true, 
        // @ts-expect-error
        onDrop: (acceptedFiles) => {
            if (props.onChange) {
                upload.mutate(acceptedFiles[0]);
            }
        } }, props.image ? (React.createElement(ImageContainer, null,
        React.createElement(X, { style: {
                float: 'right',
                cursor: 'pointer',
            }, onClick: () => {
                if (props.onChange) {
                    props.onChange(null);
                }
            } }),
        React.createElement("img", { src: `${APIBASE}/files/${props.image.fileId}/${props.image.fileName}` }))) : (React.createElement("div", null,
        React.createElement(Button, { style: {
                display: 'block',
                margin: '7px auto',
            }, loading: upload.isLoading, onClick: () => {
                // @ts-ignore
                dropzoneRef.current?.open();
            } }, "Upload"))))));
};
export default ImageInput;
const promiseFileReader = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (event) => {
            resolve(event.target.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};
const ImageContainer = styled.div `
  img {
    object-fit: contain;
    object-position: left bottom;
    margin-top: 15px;
    margin-bottom: 15px;
    height: 60px;
    width: 216px;
    margin: 0 auto;
    display: block;
  }
`;
const Styled = styled.div `
  background-color: #e6e6e6;
  border-radius: 2px;
  padding: ${THEME.GRID_SPACING}px;
  margin-bottom: ${THEME.GRID_SPACING}px;
`;
//# sourceMappingURL=ImageInput.js.map